import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { InteractiveRoomItem } from "$/game/prefabs/InteractiveRoomItem.ts";
import { sendPreparedMessage } from "$/common/telegram-utils.ts";

export class PhoneInteractiveObject extends InteractiveRoomItem {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(
      myScene,
      x,
      y,
      myScene.atlas,
      myScene.keys.assets.sprites.items.phone,
    );

    this.setOnClickCallback(async () => {
      try {
        myScene.overlay.show("LoadingOverlay", false);
        const resp = await myScene.api.user.share();

        if (resp.result?.id) {
          sendPreparedMessage(resp.result.id);
        } else {
          console.error("No message ID received from API", resp);
        }
      } catch (error) {
        console.error("Error creating share message:", error);
      }

      myScene.overlay.close("LoadingOverlay");
    });
  }

  override destroy(): void {
    super.destroy();
  }
}
